export const PERSIAN_NUMERALS: ReadonlyArray<string> = Object.freeze([
  '۰',
  '۱',
  '۲',
  '۳',
  '۴',
  '۵',
  '۶',
  '۷',
  '۸',
  '۹',
])

export const ENGLISH_NUMERALS: ReadonlyArray<string> = Object.freeze([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
])
